/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { SmsTemplateRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { SmsTemplateListItem } from './sms-templates.model';

@Injectable()
export class SmsTemplateListBusinessService implements InitViewService {
  constructor(private smsTemplateRest: SmsTemplateRestService,
              private gridLayouts: GridLayoutService) {
  }

  initView(): any {
    return {
      gridLayout: this.gridLayouts.get('smsTemplates'),
    };
  }

  findAllAsDataSource(): SlicedDataSource<SmsTemplateListItem> {
    return this.smsTemplateRest.findAllAsDataSource();
  }

  remove(item: SmsTemplateListItem): Observable<void> {
    return this.smsTemplateRest.remove(item);
  }
}
